import { render, staticRenderFns } from "./changeMenu1.0.vue?vue&type=template&id=b977b05a&scoped=true&"
import script from "./changeMenu1.0.vue?vue&type=script&lang=js&"
export * from "./changeMenu1.0.vue?vue&type=script&lang=js&"
import style0 from "./changeMenu1.0.vue?vue&type=style&index=0&id=b977b05a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b977b05a",
  null
  
)

export default component.exports